import type { PermissionSelector } from "hooks/usePermission";

// This file contains permission alongside business logic that resides in FE
// to determine if a user can access a certain page or not.
export const canAccessUserSearch: PermissionSelector = (x) => x.isSuperAdmin;

export const canAccessSystemSettings: PermissionSelector = (x) => x.isSuperAdmin;
